"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDeniedField = exports.useField = void 0;
const react_redux_1 = require("react-redux");
const core_1 = require("../core");
const use_meta_1 = require("./use_meta");
const react_1 = require("react");
const context_1 = require("../context");
const field_1 = require("../model/field");
const model_1 = require("../model");
const selector_1 = require("../store/selector");
function useField(param1, param2) {
    const { datasheetId: metaDatasheetId } = (0, use_meta_1.useMeta)();
    const hasDatasheet = param1 instanceof model_1.Datasheet;
    const fieldId = param1 instanceof model_1.Datasheet ? param2 : param1;
    const datasheetId = hasDatasheet ? param1.datasheetId : metaDatasheetId;
    const context = (0, react_1.useContext)(context_1.WidgetContext);
    const field = (0, react_redux_1.useSelector)(state => {
        var _a;
        if (!fieldId) {
            return;
        }
        return (_a = (0, selector_1.getFieldMap)(state, datasheetId)) === null || _a === void 0 ? void 0 : _a[fieldId];
    }, react_redux_1.shallowEqual);
    const fieldRole = (0, react_redux_1.useSelector)(state => {
        const fieldPermissionMap = (0, selector_1.getFieldPermissionMap)(state);
        if (!fieldId) {
            return;
        }
        return (0, selector_1.getFieldRoleByFieldId)(fieldPermissionMap, fieldId);
    });
    // If fieldRole dose not exist, the field really dose not exist, 
    // and if fieldRole is None, there is no permission to access
    return (0, react_1.useMemo)(() => {
        if (!datasheetId || !field) {
            return;
        }
        return new field_1.Field(datasheetId, context, fieldRole === core_1.ConfigConstant.Role.None ? createDeniedField() : field);
    }, [datasheetId, context, fieldRole, field]);
}
exports.useField = useField;
/** @internal */
function createDeniedField() {
    return {
        id: (0, core_1.getNewId)(core_1.IDPrefix.Field),
        name: 'NoPermission',
        type: core_1.FieldType.DeniedField,
        property: null,
    };
}
exports.createDeniedField = createDeniedField;
